var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_material-description",
    "data-name": "Icon material-description",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 24.478,
    viewBox: "0 0 20.25 24.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-description-2",
    "data-name": "Icon material-description",
    d: "M18.656,3H8.531A2.487,2.487,0,0,0,6.013,5.448L6,25.03a2.487,2.487,0,0,0,2.519,2.448h15.2A2.5,2.5,0,0,0,26.25,25.03V10.343Zm2.531,19.582H11.063V20.135H21.187Zm0-4.9H11.063V15.239H21.187Zm-3.8-6.12V4.836l6.961,6.731Z",
    transform: "translate(-6 -3)",
    fill: "var(--secondaryColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.ef07b3f92284cca4188a096dbfc57fde.svg";
export { ForwardRef as ReactComponent };